// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7f99f1ff","404":"449d40c2","498":"7c5fe483","787":"ea608e5f"}[chunkId] + ".chunk.js";
};